module.exports = __webpack_public_path__ + "assets/img/c0ffbf2d6c77f5b1d1eb5f25fb300f15.svg";